<script lang="ts">
    import {
        physicalPresenceEnabledStore,
        physicalPresenceErrorStore,
        setPhysicalPresenceEnabled,
    } from "../../Stores/PhysicalPresenceStore";

    let activating = $state(false);

    async function activatePresence(): Promise<void> {
        if (activating) {
            return;
        }
        activating = true;
        try {
            await setPhysicalPresenceEnabled(true);
        } finally {
            activating = false;
        }
    }
</script>

{#if !$physicalPresenceEnabledStore}
    <div
        class="pointer-events-auto fixed top-20 left-1/2 -translate-x-1/2 z-[1000] w-[calc(100%-2rem)] max-w-xl rounded-lg border border-amber-300/60 bg-amber-950/95 px-4 py-3 text-white shadow-xl backdrop-blur"
        role="alert"
        data-testid="physical-presence-activation-banner"
    >
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div class="min-w-0">
                <div class="font-bold text-amber-200">Presença automática desativada</div>
                <div class="text-sm leading-5">
                    Sua presença automática está desativada. Ative-a para permanecer disponível no escritório.
                </div>
                {#if $physicalPresenceErrorStore}
                    <div class="mt-1 text-xs text-amber-200">{$physicalPresenceErrorStore}</div>
                {/if}
            </div>
            <button
                type="button"
                disabled={activating}
                onclick={activatePresence}
                class="shrink-0 rounded-md bg-amber-300 px-4 py-2 font-bold text-amber-950 transition hover:bg-amber-200 disabled:cursor-wait disabled:opacity-60"
            >
                {activating ? "Ativando..." : "Ativar agora"}
            </button>
        </div>
    </div>
{/if}
